import React, { useState, useEffect, useContext, useMemo } from "react";
import { ThemeContext } from "contexts/ThemeContext.jsx";
import {
  Container,
  Card,
  Form,
  Button,
  Row,
  Col,
  Alert,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { serverHost, createEndpoints } from "variables/serverdata";
import SimpleHeader from "components/Headers/SimpleHeader.js";
import { Input } from "reactstrap";

const CallflowAddEdit = ({ method }) => {
  const edit = method === "edit";
  const dialplans = [
    { value: "transfer:*98 XML 10.0.190.48", label: "Check Voicemail" },
    { value: "transfer:*411 XML 10.0.190.48", label: "Company Directory" },
    { value: "hangup:", label: "Hangup" },
    { value: "transfer:*732 XML 10.0.190.48", label: "Record" },
  ];
  const { id } = useParams();
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    name: null,
    extension: null,
    feature_code: null,
    status: null,
    pin: null,
    dest_label: null,
    sound: null,
    destination: null,
    alt_label: null,
    alt_sound: null,
    alt_dest: null,
    context: "",
    enabled: true,
    description: null,
  });

  const currentSite = JSON.parse(localStorage.getItem("selectedSite"));
  const site_uuid = currentSite?.domain_uuid || null;
  const [extensionList, setExtensionList] = useState([]);
  const [bridgeList, setBridgeList] = useState([]);
  const [voicemailList, setVoicemailList] = useState([]);
  const [tonesList, setTonesList] = useState([]);
  const [flowsList, setFlowsList] = useState([]);
  const [ivrList, setIVRList] = useState([]);
  const [timeConditionsList, setTCList] = useState([]);
  const [destinationsList, setDestList] = useState([]);
  const [soundsList, setSoundsList] = useState([]);
  const [ringGroupList, setRingGroup] = useState([]);
  const [recordingsList, setRecordingsList] = useState([]);
  const [domainList, setDomainList] = useState([]);
  const [loading, setLoading] = useState([]);
  const endpoints = useMemo(
    () =>
      createEndpoints({
        setExtensionList,
        setBridgeList,
        setVoicemailList,
        setFlowsList,
        setIVRList,
        setTCList,
        setDestList,
        setRingGroup,
        setDomainList,
        site_uuid,
      }),
    [],
  );

  useEffect(() => {
    const fetchDomain = async (e) => {
      try {
        const currentSite = JSON.parse(localStorage.getItem("selectedSite"));
        const domain_uuid = currentSite?.domain_uuid || null;
        const response = await fetch(
          `${serverHost}/fetch_domain_name/${domain_uuid}`,
        );
        if (!response.ok) throw new Error(`Failed to fetch domain context`);
        const data = await response.json();
        setFormData((prev) => ({ ...prev, context: data.result }));
      } catch (err) {
        setError(err.message);
      }
    };
    const fetchData = async () => {
      for (const key in endpoints) {
        const { url, map, setter } = endpoints[key];
        try {
          const res = await fetch(url);
          if (!res.ok) continue;

          const data = await res.json();
          const mapped = data.results.map(map);
          console.log(key, mapped);

          setter(mapped);
        } catch (err) {
          console.error(`Failed to fetch ${key}:`, err);
        }
      }
    };
    const fetchTones = async () => {
      try {
        const res = await fetch(
          `${serverHost}/get_rows?table=v_vars&pageSize=50&page=1&cfilter=var_category&vfilter=Tones`,
        );
        if (res.ok) {
          const data = await res.json();
          console.log(data);
          const tones = data.results.map((r) => ({
            value: `playback:tone_stream://${r.var_value}`,
            name: r.var_name,
          }));
          console.log(tones);
          setTonesList(tones);
        }
      } catch (err) {
        console.error("Failed to fetch extensions:", err);
      }
    };
    const fetchSounds = async () => {
      try {
        const res = await fetch(`${serverHost}/get_sounds`);
        if (res.ok) {
          const data = await res.json();
          console.log(data);
          const sounds = data.result;
          console.log("sounds: ", sounds);
          setSoundsList(sounds);
        }
      } catch (err) {
        console.error("Failed to fetch sounds:", err);
      }
    };
    const fetchRecordings = async (e) => {
          try {
            const domain_uuid = currentSite?.domain_uuid || null;
            const response = await fetch(
              `${serverHost}/get_recordings/${domain_uuid}`,
            );
            if (!response.ok) throw new Error(`Failed to fetch domain context`);
            const data = await response.json();
            console.log(data);
            setRecordingsList(data.results || []);
          } catch (err) {
            setError(err.message);
          }
        };
    const fetchCallflow = async () => {
      try {
        const res = await fetch(
          `${serverHost}/get_row?table=v_call_flows&pk=call_flow_uuid&id=${encodeURIComponent(
            id,
          )}`,
        );
        if (!res.ok)
          throw new Error(
            res.status === 404 ? "Row not found" : "Failed to fetch row",
          );
        const data = await res.json();
        if (!data?.result) throw new Error("Row not found");
        const callflow = data.result;
        console.log(data.result);
        setFormData({
          name: callflow.call_flow_name,
          extension: callflow.call_flow_extension,
          feature_code: callflow.call_flow_feature_code,
          status: callflow.call_flow_status,
          pin: callflow.call_flow_pin_number,
          dest_label: callflow.call_flow_label,
          sound: callflow.call_flow_sound,
          destination: `${callflow.call_flow_app}:${callflow.call_flow_data}`,
          alt_label: callflow.call_flow_alternate_label,
          alt_sound: callflow.call_flow_alternate_sound,
          alt_dest:
            callflow.call_flow_alternate_app &&
            callflow.call_flow_alternate_data
              ? `${callflow.call_flow_alternate_app}:${callflow.call_flow_alternate_data}`
              : null,
          context: callflow.call_flow_context,
          enabled: callflow.call_flow_enabled,
          description: callflow.call_flow_description,
        });
      } catch (err) {
        console.error("Error fetching callflow data, ", err);
      }
    };

    const loadData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          fetchData(),
          fetchTones(),
          fetchSounds(),
          fetchRecordings(),
          edit ? fetchCallflow() : fetchDomain(),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    try {
      const site = JSON.parse(localStorage.getItem("selectedSite"));
      const payload = {
        data: {
          ...formData,
        },
        client_uuid: site.client_uuid,
        site_name: site.company_name,
        insert_uuid: JSON.parse(localStorage.getItem("user")).user_uuid,
      };
      let url = `${serverHost}/callflow/${site.site_uuid}`;
      if (edit) {
        url = `${serverHost}/update_callflow/${id}`;
        payload.site_uuid = site.site_uuid;
      }
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        // Show success message
        navigate("/admin/hucs/call-flows"); // Navigate back to call flows list
      } else {
        const error = await response.json();
        console.error("Failed to create call flow:", error);
        // Show error message
      }
    } catch (error) {
      console.error("Error creating call flow:", error);
      // Show error message
    }
  };

  const handleCancel = () => {
    navigate("/admin/hucs/call-flows"); // Navigate back to call flows list
  };

  if (loading) {
    return (
      <>
        <SimpleHeader name="Edit Inbound Route" parentName="HUCS" />
        <Container className="mt--6">
          <Card className="shadow-sm" style={{ marginTop: "-3rem" }}>
            <Card.Body className="p-4 text-center">
              <p>Loading Call Flow<span className="loading-dots"></span></p>
            </Card.Body>
          </Card>
        </Container>
      </>
    );
  }

  return (
    <>
      <SimpleHeader
        name={`${method.toUpperCase()} Call Flow`}
        parentName="HUCS"
      />
      <Container fluid className="mt--6">
        <Card className="shadow-sm" style={{ border: "none" }}>
          <Card.Header
            style={{
              backgroundColor: isDark ? "#1f2937" : "#e9ecef",
              color: isDark ? "#92368cff" : "#1e3a5f",
              borderBottom: "none",
              padding: "1rem 1.5rem",
            }}
          >
            <h5 className="mb-0" style={{ fontWeight: 600 }}>
              {method.toUpperCase()} CALL FLOW
            </h5>
          </Card.Header>

          <Card.Body
            style={{
              backgroundColor: isDark ? "#1f2937" : "#fff",
              padding: "1.5rem",
            }}
          >
            {error && <Alert variant="danger">{error}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Row className="mb-3">
                {/* Name */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: "bolder",
                      }}
                    >
                      Name <span style={{ color: "#dc3545" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter call flow name"
                      required
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    />
                  </Form.Group>
                </Col>

                {/* Extension */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: "bolder",
                      }}
                    >
                      Extension <span style={{ color: "#dc3545" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="extension"
                      value={formData.extension}
                      onChange={handleChange}
                      placeholder="Enter extension number"
                      required
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                {/* Feature Code */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Feature Code
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="feature_code"
                      value={formData.feature_code}
                      onChange={handleChange}
                      placeholder="e.g., *123"
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    />
                  </Form.Group>
                </Col>

                {/* Status */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Status
                    </Form.Label>
                    <Input
                      type="select"
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    >
                      <option key="true" value="true">
                        True
                      </option>
                      <option key="false" value="false">
                        False
                      </option>
                    </Input>
                  </Form.Group>
                </Col>

                {/* PIN */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      PIN
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="pin"
                      value={formData.pin}
                      onChange={handleChange}
                      placeholder="Enter PIN"
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                {/* Destination Label */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Destination Label
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="dest_label"
                      value={formData.dest_label}
                      onChange={handleChange}
                      placeholder="Enter destination label"
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    />
                  </Form.Group>
                </Col>

                {/* Sounds */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Sounds
                    </Form.Label>
                    <Input
                      type="select"
                      name="sound"
                      value={formData.sound}
                      onChange={handleChange}
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    >
                      <option value="">Select...</option>
                      <optgroup label="Recordings">
                        {recordingsList.map((opt) => (
                          <option
                            key={opt.recording_filename}
                            value={opt.recording_filename}
                          >
                            {opt.recording_name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="sounds">
                      {soundsList.map((opt) => (
                        <option key={opt.filename} value={opt.filename}>
                          {opt.filename}
                        </option>
                      ))}
                      </optgroup>
                    </Input>
                  </Form.Group>
                </Col>

                {/* Destination */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: "bolder",
                      }}
                    >
                      Destination <span style={{ color: "#dc3545" }}>*</span>
                    </Form.Label>
                    <Input
                      type="select"
                      name="destination"
                      value={formData.destination}
                      onChange={handleChange}
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                      required
                    >
                      <option value="">Select...</option>
                      <optgroup label="Bridges">
                        {bridgeList.map((br) => (
                          <option
                            key={br.bridge_uuid}
                            value={`bridge:${br.destination}`}
                          >
                            {br.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Call Flows">
                        {flowsList.map((cf) => (
                          <option key={cf.name} value={cf.value}>
                            {cf.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Destinations">
                        {destinationsList.map((d) => (
                          <option value={d.value}>{d.name}</option>
                        ))}
                      </optgroup>
                      <optgroup label="Extensions">
                        {extensionList.map((ext) => (
                          <option
                            key={ext.extension_uuid}
                            value={`transfer:${ext.name} XML ${ext.accountcode}`}
                          >
                            {ext.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="IVR Menus">
                        {ivrList.map((ivr) => (
                          <option key={ivr.name} value={ivr.value}>
                            {ivr.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Ring Groups">
                        {ringGroupList.map((r) => (
                          <option key={r.name} value={`transfer:${r.value}`}>
                            {r.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Time Conditions">
                        {timeConditionsList.map((tc) => (
                          <option key={tc.name} value={tc.value}>
                            {tc.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Tones">
                        {tonesList.map((tone) => (
                          <option key={tone.name} value={tone.value}>
                            {tone.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Voicemails">
                        {voicemailList.map((vm) => (
                          <option key={vm.voicemail_uuid} value={vm.value}>
                            {`${vm.voicemail_id} ${vm.voicemail_description}`}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Dialplans">
                        {dialplans.map((dp) => (
                          <option key={dp.value} value={dp.value}>
                            {dp.label}
                          </option>
                        ))}
                      </optgroup>
                    </Input>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                {/* Alt Label */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Alt Label
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="alt_label"
                      value={formData.alt_label}
                      onChange={handleChange}
                      placeholder="Enter alternate label"
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    />
                  </Form.Group>
                </Col>

                {/* Alt Sounds */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Alt Sounds
                    </Form.Label>
                    <Input
                      type="select"
                      name="alt_sound"
                      value={formData.alt_sound}
                      onChange={handleChange}
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    >
                      <option value="">Select...</option>
                      {soundsList.map((opt) => (
                        <option key={opt.filename} value={opt.filename}>
                          {opt.filename}
                        </option>
                      ))}
                    </Input>
                  </Form.Group>
                </Col>

                {/* Alt Destination */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Alt Destination
                    </Form.Label>
                    <Input
                      type="select"
                      name="alt_dest"
                      value={formData.alt_dest}
                      onChange={handleChange}
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    >
                      <option value="">Select...</option>
                      <optgroup label="Bridges">
                        {bridgeList.map((br) => (
                          <option
                            key={br.bridge_uuid}
                            value={`bridge:${br.destination}`}
                          >
                            {br.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Call Flows">
                        {flowsList.map((cf) => (
                          <option key={cf.name} value={`transfer:${cf.value}`}>
                            {cf.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Destinations">
                        {destinationsList.map((d) => (
                          <option value={`transfer:{d.value}`}>{d.name}</option>
                        ))}
                      </optgroup>
                      <optgroup label="Extensions">
                        {extensionList.map((ext) => (
                          <option
                            key={ext.extension_uuid}
                            value={`transfer:${ext.name} XML ${ext.accountcode}`}
                          >
                            {ext.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="IVR Menus">
                        {ivrList.map((ivr) => (
                          <option
                            key={ivr.name}
                            value={`transfer:${ivr.value}`}
                          >
                            {ivr.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Time Conditions">
                        {timeConditionsList.map((tc) => (
                          <option key={tc.name} value={`transfer${tc.value}`}>
                            {tc.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Tones">
                        {tonesList.map((tone) => (
                          <option key={tone.name} value={tone.value}>
                            {tone.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Voicemails">
                        {voicemailList.map((vm) => (
                          <option
                            key={vm.voicemail_uuid}
                            value={`transfer:${vm.value}`}
                          >
                            {vm.voicemail_id}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Dialplans">
                        {dialplans.map((dp) => (
                          <option key={dp.value} value={dp.value}>
                            {dp.label}
                          </option>
                        ))}
                      </optgroup>
                    </Input>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                {/* Context */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: "bolder",
                      }}
                    >
                      Context <span style={{ color: "#dc3545" }}>*</span>
                    </Form.Label>
                    <Input
                      type="text"
                      name="context"
                      value={formData.context}
                      onChange={handleChange}
                      style={{
                        backgroundColor: isDark ? "#000000ff" : "#beb6b6ff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                      disabled
                    />
                  </Form.Group>
                </Col>

                {/* Enabled Toggle */}
                <Col md={6} className="d-flex align-items-end">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                      marginBottom: "1.5rem",
                    }}
                  >
                    <span
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: "bolder",
                      }}
                    >
                      Enabled <span style={{ color: "#dc3545" }}>*</span>
                    </span>

                    <label className="custom-toggle mb-0">
                      <input
                        type="checkbox"
                        id="enabled"
                        name="enabled"
                        checked={formData.enabled === "true"}
                        onChange={handleChange}
                      />
                      <span
                        className="custom-toggle-slider rounded-circle"
                        data-label-off="Off"
                        data-label-on="On"
                      />
                    </label>
                  </div>
                </Col>
              </Row>

              <Row className="mb-3">
                {/* Description */}
                <Col md={12}>
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: isDark ? "#e2e8f0" : "#495057",
                        fontWeight: 500,
                      }}
                    >
                      Description
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      placeholder="Enter description"
                      style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Action Buttons */}
              <div className="d-flex justify-content-between mt-4">
                <Button variant="danger" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button
                  variant="success"
                  onClick={handleSubmit}
                  disabled={
                    !formData.extension ||
                    !formData.name ||
                    !formData.destination
                  }
                >
                  {method.toUpperCase()} Call Flow
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default CallflowAddEdit;
